import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

let emssData;
let icligmData;
let saasData;
let cloudData;
let iclreactData = "";
let iclCBData = "";

const About = (props) => {
  const { onFeatureDataLoaded } = props;
  const [data, setData] = useState({ paragraph: "Loading...", Why: [] });
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {

    fetch(`https://servguest.eximon.com/ServConI?page=INDEX&timestamp=${encodeURIComponent(new Date().getTime())}`)
      .then((response) => response.text())
      .then((fetchedData) => {
        const lines = fetchedData.split('\n');
        let aboutData = "About data not found";

        for (let line of lines) {
          if (line.trim().startsWith("aboutus")) {
            aboutData = line.trim().substring(7);
            //            break;
          }
          if (line.trim().startsWith("remss")) {
            emssData = line.trim().substring(5);
          }
          if (line.trim().startsWith("ricligm")) {
            icligmData = line.trim().substring(7);
          }
          if (line.trim().startsWith("rsaas")) {
            saasData = line.trim().substring(5);
          }
          if (line.trim().startsWith("rcloud")) {
            cloudData = line.trim().substring(6);
          }
          if (line.trim().startsWith("riclreact")) {
            iclreactData = line.trim().substring(9);
          }
          if (line.trim().startsWith("riclchatbot")) {
            iclCBData = line.trim().substring(11);
          }
        }
        onFeatureDataLoaded?.({
          EMSS: emssData,
          ICLIGM: icligmData,
          SaaS: saasData,
          Cloud: cloudData,
          "ICL Reacts": iclreactData,
          "ICL ChatBot": iclCBData,
        });
        //        console.log("About Data:", aboutData); console.log("EMSS Data:", emssData); console.log("ICLIGM Data:", icligmData); console.log("SAAS Data:", saasData); console.log("Cloud Data:", cloudData); console.log("ICLReact Data:", iclreactData);
        setData((prevData) => ({ ...prevData, paragraph: aboutData }));
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [onFeatureDataLoaded]);

  // Function to toggle the "Read more" state
  const toggleReadMore = () => {
    const paragraphs = document.getElementById('about').getElementsByTagName('p');
    const aboutParagraph = paragraphs[maxLines];

    if (expanded) {
      // If currently expanded, scroll to the top of the container
      document.getElementById('about').scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // If not expanded, scroll to the top of the expanded content
      aboutParagraph.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    for (let i = maxLines; i < paragraphs.length; i++) {
      paragraphs[i].style.display = expanded ? 'none' : 'block';
    }
    setExpanded(!expanded);
  };

  // Function to create an HTML element from the string
  const createMarkup = (htmlString) => ({ __html: htmlString });

  const maxLines = 2; // The maximum number of lines to display

  // Function to limit the number of lines displayed
  const truncateText = (text) => {
    if (text) {
      const div = document.createElement('div');
      div.innerHTML = text;

      const paragraphs = div.getElementsByTagName('p');
      if (paragraphs.length > maxLines) {
        for (let i = maxLines; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'none';
        }
      }

      return div.innerHTML;
    }
    return text;
  };

  return (
    <div id="about">
      {props.isStandalone && (
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>About ICL Software Solutions | Immortal Computer Lab Pvt. Ltd.</title>

        <link rel="canonical" href="https://eximon.com/about/" />

        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Immortal Computer Lab Pvt. Ltd. (ICL), founded in 1992, is a family-owned software company delivering enterprise solutions for maritime, logistics, and export-import trade."
        />

        {/* Open Graph */}
        <meta property="og:title" content="About Immortal Computer Lab Pvt. Ltd." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eximon.com/about/" />
        <meta
          property="og:description"
          content="Learn about Immortal Computer Lab Pvt. Ltd., a family-owned software company founded in 1992, specializing in enterprise solutions for maritime and export-import trade."
        />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Immortal Computer Lab Pvt. Ltd." />
        <meta
          name="twitter:description"
          content="Immortal Computer Lab Pvt. Ltd., founded in 1992, delivers enterprise solutions for maritime and export-import trade."
        />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
        <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AboutPage",
      "@id": "https://eximon.com/about",
      "url": "https://eximon.com/about",
      "name": "About ICL Software Solutions",
      "description": "Learn about ICL Software Solutions, our mission, products, and technology expertise.",
      "inLanguage": "en",
      "isPartOf": {
        "@id": "https://eximon.com/"
      }
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://eximon.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About",
          "item": "https://eximon.com/about"
        }
      ]
    }
  ]
}
`}
</script>
      </Helmet>
)}
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="/img/about.jpg" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h1>About us</h1>

              {/* Render limited lines with "Read more" link */}
              <div
                className={`about-paragraph ${expanded ? 'expanded' : 'truncated'}`}
                dangerouslySetInnerHTML={createMarkup(
                  expanded ? `${data.paragraph}  <a href="/privacy-policy" style="float: right;"><h4>Privacy Policy</h4></a>` : truncateText(data.paragraph)
                )}
              />
              {data.paragraph.length > maxLines && (
                <button onClick={toggleReadMore} className="btn-custom">
                  {expanded ? 'Read less' : 'Read more'}
                </button>
              )}

              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data.paragraph !== "Loading..." && data.Why.map((d, i) => (
                      <li key={`${d}-${i}`}>{d}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { emssData, icligmData, saasData, cloudData, iclreactData, iclCBData };
export default About;
